<section class="say-hello">
	<section class="section scrolling" id="item-a">
		<section class="gennius--intro">
			<div class="container gennius">
				<div class="gennius__bloque gennius__bloque">
					<div class="gennius__left gennius__left--intro">
						<h1>From novae<br> to Gennius.<br><strong>From the Big<br> Bang to the<br> Blockchain.</strong></h1>
					</div>
				</div>
				<div class="gennius__bloque gennius__bloque">
					<div class="gennius__left">
						<span>In the beginning, a star was born out of the collision of two. The cosmic explosion gave birth to
							a greater star known as <strong>novae</strong>.</span>
						<p><strong>10 years later, that star has exponentially <br>grown into a supernova.</strong> A fusion of rewards, crypto and
							fiat currencies originated a new star, brighter, bigger and more powerful than ever. <strong>Our blue dwarf
							was born. </strong><br><br> <strong class="especial">Welcome to the age of Gennius.</strong></p>
						</div>
				</div>
			</div>
				<!-- <div class="gennius__center">
					<img class="gennius__img gennius__img--intro2" src="./assets/img/gennius/about-image-intro.png">
					<a class="btn-v btn-gennius" id="btn-i">Discover our evolution</a>
				</div> -->
		</section>
	</section>
	<section class="section gennius--powering" id="item-b">
		<div class="bg-wrap">
			<div class="bg">
				<!-- <app-connect></app-connect> -->
			</div>
		</div>
		<div class="gennius__center">
			<h1 class="text-gradient">Powering global commerce </h1>
			<span class="sub">by reimagining the digital<br> asset ecosystem.</span>
			<p>We want to bring up the lifestyle of human beings with more spending power to buy all the things they love, anywhere in the world, all <strong>within one</strong>.</p>
		</div>
		<img class="gennius__img gennius__img--intro2" src="./assets/img/gennius/about-image-intro.png">

	</section>
	

	<section class="section section-parallax parallax-1" id="item-c">
		<div class="bg-wrap">
			<div class="bg">
				<div class="gradient"></div>
				<app-connect></app-connect>
				<div class="container gennius">
					<div class="gennius__bloque">
						<div class="gennius__left">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-one.webp">
						</div>
						<div class="gennius__right">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-1.png">

							<owl-carousel class="slide-parallax" [options]="slideParallax" [carouselClasses]="['owl-theme', 'sliding']">
								<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-1.png">
								<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-2.png">
								<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-3.png">
								<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-4.png">
							</owl-carousel>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <a class="btn-v btn-gennius" pageScroll href="#solutions" [routerLink]="['/solutions']">Experience our platform</a> -->
	</section>

	<section class="section section-parallax" id="item-d">
		<div class="bg-wrap">
			<div class="bg">
				<div class="gradient"></div>
				<app-connect></app-connect>
				<div class="container gennius">
					<div class="gennius__bloque">
						<div class="gennius__left">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-one.webp">
						</div>
						<div class="gennius__right">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-2.png">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section section-parallax" id="item-e">
		<div class="bg-wrap">
			<div class="bg">
				<div class="gradient"></div>
				<app-connect></app-connect>
				<div class="container gennius">
					<div class="gennius__bloque">
						<div class="gennius__left">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-one.webp">
						</div>
						<div class="gennius__right">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-3.png">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section section-parallax parallax-4" id="item-f">
		<div class="bg-wrap">
			<div class="bg">
				<div class="gradient"></div>
				<app-connect></app-connect>
				<div class="container gennius">
					<div class="gennius__bloque">
						<div class="gennius__left">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-one.webp">
						</div>
						<div class="gennius__right">
							<img class="gennius__img gennius__img--layout" src="./assets/img/gennius/image-parallax-4.png">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section gennius--layout gennius--network" id="item-g">
		<div class="bg-wrap">
			<div class="bg">
				<div class="gradient"></div>
				<app-connect></app-connect>
			</div>
		</div>
		<div class="titulo-network">
			<span class="text-gradient">O</span>
			<span class="text-gradient">n</span>
			<span class="text-gradient">e</span>
			<span>network</span>
		</div>
		<img class="gennius__img gennius__img--layout" src="./assets/img/logo-gennius.svg">
		<div class="target1"></div>
	</section>
	<section class="section scrolling" id="item-h">
		<section class="gennius--element">
			<div class="container gennius">
				<div class="gennius__center gennius__center--element">
					<h1>The fifth element of </h1>
					<span>Gennius</span>
					<span class="sub">According to ancient philosophy, <strong>five elements</strong> make up all matter in the universe. In the
						same way, <strong>five elements</strong> are the foundation of digital payments, rewards, and the blockchain world. These
						elements work in unison to deliver best-in-class experiences for cardholders and crypto holders around
						the world:</span>
				</div>
			</div>
			<owl-carousel [options]="SlideOptions" [carouselClasses]="['owl-theme', 'sliding']">
				<div class="item item-1 slide-1">
					<div class="content">
						<img src="./assets/img/gennius/slide-icon-1.png" alt="">
						<h3>Rewards and payment processing</h3>
						<p>Enables the global flow of digital money across merchants</p>
					</div>
				</div>
				<div class="item item-2 slide-2">
					<div class="content">
						<img src="./assets/img/gennius/slide-icon-2.png" alt="">
						<h3>Marketplace</h3>
						<p>A connected world of over 100 million merchants provides the foundation of our super network of apps.
						</p>
					</div>
				</div>
				<div class="item item-3 slide-2">
					<div class="content">
						<img src="./assets/img/gennius/slide-icon-3.png" alt="">
						<h3>Benefits</h3>
						<p>Strong reasons to believe in our digital solutions and the stronghold of discounts, rewards and care
							programs.</p>
					</div>
				</div>
				<div class="item item-4 slide-2">
					<div class="content">
						<img src="./assets/img/gennius/slide-icon-4.png" alt="">
						<h3>Blockchain</h3>
						<p>Over 250 cryptocurrencies enable a global market of lightning-fast, transparent, and secure transactions in the blockchain.</p>
					</div>
				</div>
				<div class="item item-5 slide-3 target0">
					<div class="content">
						<h3>The Fifth Element</h3>
						<img class="logo-slide" src="./assets/img/gennius/logo-cymi.png" alt="">
						<p>the first interoperability token connecting loyalty programs, fiat currencies and the crypto market.</p>
					</div>
				</div>
			</owl-carousel>
		</section>
	</section>
	<section class="section scrolling" id="item-h">
		<section class="section gennius--disruption"  id="item-i">
			<div class="container gennius">
				<div class="gennius__center gennius__center--element">
					<h1>10 years</h1>
					<span class="text">of stellar tech disruption</span>
					<span class="sub">From e-commerce to digital currencies to digital processing platforms into Web3</span>
				</div>
			</div>
			<mat-horizontal-stepper (selectionChange)="selectionChange($event)" #stepper>
				<div class="container">
					<mat-step label="2013" extendedStep >
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">13</strong></div>
									<div class="text">
										<p>Launch of our e-commerce processing platform with CyberSource as a partner</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">14</strong></div>
									<div class="text">
										<p>allegra platform is born providing a user friendly ecommerce solution for banks in Latin America</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-1.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-2.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2014" extendedStep>
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">13</strong></div>
									<div class="text">
										<p>Launch of our e-commerce processing platform with CyberSource as a partner</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">14</strong></div>
									<div class="text">
										<p>allegra platform is born providing a user friendly ecommerce solution for banks in Latin America</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-1.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-2.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2016">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">16</strong></div>
									<div class="text">
										<p>onepocket is conceived: a disruptive e-wallet that allows users to combine rewards and credit cards into one digital currency</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">17</strong></div>
									<div class="text">
										<p>Signed partnership agreement with Visa Inc. to co-create a best-in-class experience to revamp their loyalty program. Delivering an all-digital, omnichannel, white label solution to participating banks in LAC</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-3.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-4.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2017">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">16</strong></div>
									<div class="text">
										<p>onepocket is conceived: a disruptive e-wallet that allows users to combine rewards and credit cards into one digital currency</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">17</strong></div>
									<div class="text">
										<p>Signed partnership agreement with Visa Inc. to co-create a best-in-class experience to revamp their loyalty program. Delivering an all-digital, omnichannel, white label solution to participating banks in LAC</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-3.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-4.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2018">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">18</strong></div>
									<div class="text">
										<p>Introduced My Rewards, Visa’s loyalty program, under Solutions (VLS) adopting a proprietary e-wallet and platform in LAC: 30 countries and 47 banks, totaling $15.6M available points </p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">19</strong></div>
									<div class="text">
										<p>Miles is born! Our all in one Digital Currency enabling users to instantly redeem rewards balances at any POS (online or in-store) merchants around the world.</p>
										<p>Boosted functionalities, integrating new banking features to strengthen our smart payment platform (NSP) and digital capability framework (DCF).</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-5.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-6.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2019">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">18</strong></div>
									<div class="text">
										<p>Introduced My Rewards, Visa’s loyalty program, under Solutions (VLS) adopting a proprietary e-wallet and platform in LAC: 30 countries and 47 banks, totaling $15.6M available points </p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">19</strong></div>
									<div class="text">
										<p>Miles is born! Our all in one Digital Currency enabling users to instantly redeem rewards balances at any POS (online or in-store) merchants around the world.</p>
										<p>Boosted functionalities, integrating new banking features to strengthen our smart payment platform (NSP) and digital capability framework (DCF).</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-5.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-6.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2020">
						<div class="item">
							<div class="container">
								<div class="bloque bloque-width">
									<div class="date"><span>20</span><strong class="text-gradient">20</strong></div>
									<div class="text">
										<p>Launched LifeMiles Miles Care changing the Travel Protection experience forever.  Miles Care is the first solution ever to combine travel benefits, automated support, and instant funds in a single app for unparalleled peace of mind during travel.</p>
										<p>Introduced My Rewards 2.0, a revolution for universal redemption.  Visa Loyalty Solutions expands its service offering enabling users to instantly redeem rewards points at over 70 million merchants around the world.  My Rewards 2.0 embraces state-of-the-art user experience instantly issuing the Miles Visa Digital Card to transact online or contactless with all major wallets (Apple Pay, G-Pay, Samsung Pay, and PayPal among others)</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container center">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-9.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2021">
						<div class="item">
							<div class="container">
								<div class="bloque bloque-width">
									<div class="date"><span>20</span><strong class="text-gradient">21</strong></div>
									<div class="text">
										<p>Launched MoreFares giving frequent flyers even more travel options when using their LifeMiles miles.</p>
										<p>Say hello to miles, a Super App designed to achieve unparalleled loyalty effect, combining all digital payment solutions into one holistic, powerful platform. The most comprehensive program ever launched that provides a single place to pay and get paid, collect, redeem and transfer built-in rewards.</p>
										<p>Expanding partnerships to umbrella-signing agreements with Priceline Partner Networks and OGICO | AXA. Priceline enables a more robust travel content offering as well as better deals users can enjoy in flights, travel and car rentals worldwide. OGICO | AXA broadens the company’s care products fortifying travel protection benefits for users to travel peace of mind.</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-10.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-11.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2022">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">22</strong></div>
									<div class="text">
										<p>cryptMi unveils the world’s first dynamic card that allows users to blend all digital assets to pay for everyday essentials, NFTs and purchases in the Web3, by making dynamic and instant swaps between rewards, crypto and local currencies. Developed in partnership with VISA and Coinbase, the solution enables cardholders to buy anything in the world by removing currency and merchant constraints.</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">23</strong></div>
									<div class="text">
										<p>Launch of a token like no other, CYMi—a cryptoasset that runs on the Ethereum blockchain, offering interoperability between loyalty programs, marketplaces, merchants and the crypto liquidity market.</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-13.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-14.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
					<mat-step label="2023">
						<div class="item">
							<div class="container">
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">22</strong></div>
									<div class="text">
										<p>cryptMi unveils the world’s first dynamic card that allows users to blend all digital assets to pay for everyday essentials, NFTs and purchases in the Web3, by making dynamic and instant swaps between rewards, crypto and local currencies. Developed in partnership with VISA and Coinbase, the solusion enables cardholders to buy anything in the world by removing currency and merchant constraints.</p>
									</div>
								</div>
								<div class="bloque">
									<div class="date"><span>20</span><strong class="text-gradient">23</strong></div>
									<div class="text">
										<p>Launch of a token like no other, CYMi—a cryptoasset that runs on the Ethereum blockchain, offering interoperability between loyalty programs, marketplaces, merchants and the crypto liquidity market.</p>
									</div>
								</div>
							</div>
							<div class="bloque-bottom">
								<div class="line"></div>
								<div class="container">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-13.png" alt="gennius">
									<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-14.png" alt="gennius">
								</div>
							</div>
						</div>
					</mat-step>
				</div>
			</mat-horizontal-stepper>
			<!-- <owl-carousel [options]="SlideDisruption" [carouselClasses]="['owl-theme', 'sliding']">
				<div class="item">
					<div class="container">
						<div class="bloque">
							<div class="date"><span>20</span><strong class="text-gradient">13</strong></div>
							<div class="text">
								<p>Launch of our e-commerce processing platform with CyberSource as a partner</p>
							</div>
						</div>
						<div class="bloque">
							<div class="date"><span>20</span><strong class="text-gradient">14</strong></div>
							<div class="text">
								<p>allegra platform is born providing a user friendly ecommerce solution for banks in Latin America</p>
							</div>
						</div>
					</div>
					<div class="bloque-bottom">
						<div class="line"></div>
						<div class="container">
							<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-1.png" alt="gennius">
							<img class="gennius__img gennius__img--intro" src="./assets/img/gennius/disruption-icon-2.png" alt="gennius">
						</div>
					</div>
				</div>
				<div class="item">
					<div class="container">
						<div class="bloque">
							<div class="date"><span>20<strong>13</strong></span></div>
							<div class="text">
								<p>Launch of our e-commerce processing platform with CyberSource as a partner</p>
							</div>
						</div>
						<div class="bloque">
							<div class="date"><span>20<strong>14</strong></span></div>
							<div class="text">
								<p>allegra platform is born providing a user friendly ecommerce solution for banks in Latin
									America</p>
							</div>
						</div>
					</div>
				</div>
				<div class="item">
					<div class="container">
						<div class="bloque">
							<div class="date"><span>20<strong>13</strong></span></div>
							<div class="text">
								<p>Launch of our e-commerce processing platform with CyberSource as a partner</p>
							</div>
						</div>
						<div class="bloque">
							<div class="date"><span>20<strong>14</strong></span></div>
							<div class="text">
								<p>allegra platform is born providing a user friendly ecommerce solution for banks in Latin
									America</p>
							</div>
						</div>
					</div>
				</div>
			</owl-carousel>
			-->
		</section>
	</section>
	<section class="section scrolling">
		<section class="gennius--leadership">
			<div class="gradient"></div>
			<div class="container gennius">
				<div class="gennius__center">
					<h1>Our mass disruptors</h1>
					<span class="sub"><strong>Our leaders are more than decision makers;</strong> they are natural doers, tireless inventors, proven oracles, market whisperers, tech evangelists and rebels by nature.</span>
				</div>
				<span class="tittle-leadership">Leadership</span>
				<div class="gennius__bloque gennius__bloque--top gennius__bloque--leadership">
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-1.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CDDO | CEO </span>
							<p><strong>Sergio Arana</strong>A natural-born entrepreneur and disruptor, Sergio has developed and
								harnessed cutting-edge technologies for global financial services, insurance, healthcare and
								travel industries for over 30 years. The global travel insurance programs, innovation products,
								platforms and policies he has developed have been adopted around the world by companies the
								likes of Visa, Travel Guard, AIG among others banks and merchants.</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-12.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">SVP, GLOBAL HEAD OF<br> BUSINESS DEVELOPMENT</span>
							<p><strong>Jose Cuevas</strong>Highly accomplished professional with over two decades of expertise in the fintech payments industry. He has an extensive track record of improving payment experiences for both consumers and businesses on a global scale. Throughout his career at internationally recognized organizations like Visa, Riu Hotels, and Marsans Travel, Jose has demonstrated an unwavering focus on developing innovative and pioneering solutions that drive growth, profitability, and organizational success.</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-6.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">PARTNER</span>
							<p><strong>Anish Reddy </strong>Anish is a third-generation entrepreneur in his family business, which has interests in Alcobev Distilleries, Aerospace Ventures and Technology Platforms. He is the founder of Pursue Hard Seltzer, India’s leading Hard Seltzer brand, and also manages an alternative asset focused fund, Funicular Capital, out of Miami, Florida. His love for platform-focused technologies got him to take on a partnership role at the Miami-based FinTech venture, cryptMi.</p>
						</div>
					</div>



					<!-- <div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-2.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CCO LAC REGION</span>
							<p><strong>Zwannee Linares</strong>She is a senior executive with over 25 years of experience.
								Business growth strategist with a background in corporate sales/client management, marketing,
								and leadership. Her career expands over several industries including telecommunications, the
								airline industry, and recently into the Fintech world. Proven track record in creating and
								executing commercial strategies that</p>
						</div>
					</div> -->
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-13.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CPO</span>
							<p><strong>Luis Eduardo Tobian</strong>With over 30 years of experience in technology, operations, business development, and product management, Luis Eduardo has built an impressive career as a CTO working with multinational technology companies, financial services, and the travel industry. Having worked with prestigious clients like Amadeus, Banco AvVillas or Experian, Luis Eduardo has significantly contributed to developing valuable partnerships to create cutting-edge technology-driven complementary products.
							</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-4.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CTO</span>
							<p><strong>Yovani Isaza</strong>Yovani has proven to be an efficient liaison between C-level management and technology, product, operations, and other cross-functional teams. Even though he holds a strong background in information sciences, Yovani has evolved into other areas of expertise such as Travel Operations, Fintech, Blockchain, Digital payments, and Cryptocurrencies, fields he has focused on throughout the 15+ years of his successful career.
							</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-3.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">COO</span>
							<p><strong>Rodrigo McCarthy</strong>He is a senior international executive in the payments industry.
								After holding multiple high-level positions during his 12 year tenure with Visa, he has intimate
								knowledge of the issuer and acquiring businesses and a clear understanding of how the new
								technologies and channels are shaping the marketplace.</p>
						</div>
					</div>




					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-5.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CYMi - TOKENOMICS</span>
							<p><strong>Andres Navarre</strong>Andres has more than 20 years of experience in the IT industry, having held several positions in companies such as Intel Corporation and the United Nations. Andres has been involved in blockchain and cryptocurrencies since 2016, participating in the Geeq Corporation, Blocnova Ventures Limited and RISE-Ops, mixing his technical and business acumen. </p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-14.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">PARTNER MEXICO</span>
							<p><strong>Francisco Delgado</strong>Francisco is an accomplished executive with over three decades of experience in the Financial Services and Consumer Goods sectors. In his trajectory, he has demonstrated effective leadership at industry-leading companies such as Banco Azteca, Visa, and P&G, while consistently driving growth and pioneering innovation. His expansive understanding of market dynamics, technology trends, and consumer behavior uniquely positions him as a strategic force within the industry.</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-7.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">HEAD OF MILES CARE</span>
							<p><strong>Karen Vizard</strong>Experienced insurance expert with 25+ years of experience in the
								(re)insurance market managing a global healthcare portfolio and products.
							</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership gennius__column--leadership--especial">
						<!-- <img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-8.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">CFO</span>
							<p><strong>Gerardo Grajales</strong>Seasoned executive with more than 30 years of management experience leading complex negotiations, business integrations, start-ups, value creation, talent development, IPO and NYSE listing.<span>*Independent Contractor </span>
							</p>
						</div> -->
					</div>
					<div class="gennius__column gennius__column--leadership gennius__column--leadership--especial">
					</div>
				</div>
				<span class="tittle-leadership">Advisors</span>
				<div class="gennius__bloque gennius__bloque--top gennius__bloque--leadership">
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-9.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">ADVISOR</span>
							<p><strong>Isela Costantini</strong>She is the current CEO of GST - a Financial Holding Group,
								former President of Aerolíneas Argentinas (2016-2017), and former President and Managing
								Director of Argentina, Uruguay and Paraguay for General Motors (2012-2015). She is a very
								well-recognized businesswoman with proven international experience, who is responsible for
								helping novae achieve its ambitious growth targets.</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-10.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">ADVISOR</span>
							<p><strong>Eduardo Erana</strong>After serving as President of Visa Inc. LAC for 13 years, he began
								a career in advisory to noteworthy companies. In addition to his work with novae, he now serves
								as: Advisor to the Board of Directors of LifeMiles Board member of Grupo LaFise ( since
								2016)Board member of Abanca Corporacion Bancaria.</p>
						</div>
					</div>
					<div class="gennius__column gennius__column--leadership">
						<img class="gennius__img gennius__img--leadership" src="./assets/img/gennius/leadership-11.png"
							alt="gennius">
						<div class="gennius__content gennius__content--leadership">
							<span class="text-gradient">FINANCIAL ADVISOR</span>
							<p><strong>Jose Souto </strong>He served as CFO for Visa Inc’s European region from 2016 to 2019, at
								which time he helped to double revenues, triple after tax profits, and increase the value of the
								business from EUR 25B to EUR 50 B. He has also served as member of the Visa Europe Limited Board
								and a Senior Vie President of the Global Finance Organization.</p>
						</div>
					</div>
				</div>
				<span class="tittle-leadership">Our investors</span>
				<div class="gennius__center">
					<span class="sub sub--investors"><strong>CASEIF III LP</strong>, a private equity fund that includes investors such as: The International Finance Corporation – <strong
						>IFC</strong>, of World Bank Group; Norwegian Investment Fund for Developing Countries –
						<strong>NORFUND</strong>; Swiss Investment Fund for Emerging Markets – <strong
						>SIFEM</strong>; Impact Investing <strong>SME</strong> Focus Fund –
						<strong>IIF SME LP of UBS Bank</strong>, both of them managed by <strong
						>OBVIAM AG;</strong> Dutch Development Bank – <strong>FMO</strong>;
						Andean Development Corporation – <strong>CAF</strong>; Madagascar Biodiversity Fund – <strong
						>FAPBM</strong>; and <strong>LAFISE Group – LAFISE</strong>; Seven Seas Group - India.</span>
				</div>
			</div>
		</section>
		<app-footer></app-footer>
		<section class="section clearBoth"></section>
	</section>
</section>
